// extracted by mini-css-extract-plugin
module.exports = {"container":"_9400a595a7--container--bHAwU","container-desktop":"_9400a595a7--container-desktop--GspPw"};